<template>
  <div>
    <div class="title-div">燃气查询</div>
    <div>
      <div class="query-div">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="燃气户号">
            <el-input v-model="formInline.gasAccount" placeholder="请输入燃气户号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="query-button" @click="checkUserGas()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="account-div">
        <img src="../../../assets/fu-wu/zdjl.png" style="vertical-align:middle;"><span>账单记录</span>
      </div>

      <div class="table-div">

        <template>
          <el-table

            :data="tableData"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            v-loading="loading"
            style="width: 100%">

            <el-table-column
              v-if="flag === 'chargeHis'"
              align="center"
              label="账单时间"
              prop="PayDate"
              width="180">
            </el-table-column>

            <el-table-column
              v-if="flag === 'billHis'"
              align="center"
              label="账单时间"
              prop="BillDate"
              width="180">
            </el-table-column>

            <el-table-column
              align="center"
              label="用户编号"
              prop="userNo"
              width="160">
              <template>
                <!--<span>
                  {{this.obj.userCode}}
                </span>-->
                <span>
                  {{topMainArr[0].value}}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              label="表形"
              prop="meterType">
              <template>
                <!--<span>{{this.obj.meterType ==='C' ? '卡表': this.obj.meterType ==='R' ? '普表' : this.obj.meterType ==='NB' ? '智能表':this.obj.meterType}}</span>-->
                <span>
                  {{topMainArr[1].value}}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              label="地址"
              prop="address"
              width="400">
              <template>
                <!--<span>{{this.obj.address}}</span>-->
                <span>{{topMainArr[2].value}}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="flag === 'chargeHis'"
              align="center"
              label="缴费金额"
              prop="PayAmt"
              width="160">
              <template slot-scope="scope">
                <span style="color: red;font-weight: bolder">{{ scope.row.PayAmt }}</span>元
              </template>
            </el-table-column>

            <el-table-column
              v-if="flag === 'billHis'"
              align="center"
              label="缴费金额"
              prop="BillAmt"
              width="160">
              <template slot-scope="scope">
                <span style="color: red;font-weight: bolder">{{ scope.row.BillAmt }}</span>元
              </template>
            </el-table-column>

          </el-table>
        </template>

      </div>
      <div class="page-div">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          background
          layout=" prev, pager, next, jumper"

        >
        </el-pagination>
      </div>
    </div>
  </div>

</template>

<script>
  import { getInfo, getBjtongAccessToken, checkUserGas, operationRecords } from '../../../api/accountInformation'
  import { getToken } from '../../../api/login'

  export default {
    name: 'GasAccountInfo',
    data () {

      return {
        loading: false,
        flag: '',
        obj: {},
        topMainArr: [
          {
            title: '用户编号：',
            value: ''
          },
          {
            title: '表型：',
            value: ''
          },
          {
            title: '地址：',
            value: ''
          }
        ],
        billArr: [],
        tableData: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        code: '', // 统一认证平台返回的code
        telephone: '', // 登录时的用户名
        password: '', // 登录密码
        formInline: {
          gasAccount: '' // 燃气户号-查询条件
        }
      }
    },
    mounted () {
      this.code = this.$route.query.code
      console.log('统一认证平台返回的code为', this.code)
      this.getBjtongAccessToken(this.code)
      /*this.obj = this.$store.state.cardObj
      this.topMainArr[0].value = this.obj.userCode
      // C卡表，R普表，NB智能表
      if (this.obj.meterType === 'C') {
        this.topMainArr[1].value = '卡表'
      }
      if (this.obj.meterType === 'R') {
        this.topMainArr[1].value = '普表'
      }
      if (this.obj.meterType === 'NB') {
        this.topMainArr[1].value = '智能表'
      }
      this.topMainArr[2].value = this.obj.address

      this.total = this.billArr.length
      this.getData()*/
    },
    methods: {
      getData () {
        const that = this
        that.loading = true
        const obj = {
          'CM-MOB-IF06': {
            input: {
              UniUserCode: that.formInline.gasAccount
            }
          }
        }
        getInfo(JSON.stringify(obj)).then(res => {
          if (res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.billHis) {
            that.loading = false
            that.billArr = res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.billHis
            console.log('billHis--' + that.billArr)
            that.total = that.billArr.length
            that.flag = 'billHis'
            that.handleCurrentChange(1)
            return
          }
          if (res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.chargeHis) {
            that.loading = false
            that.billArr = res.data['soapenv:Envelope']['soapenv:Body']['CM-MOB-IF06'].output.chargeHis
            that.total = that.billArr.length
            that.flag = 'chargeHis'
            console.log('chargeHis--' + that.billArr)
            that.handleCurrentChange(1)
          } else {
            that.loading = false
            that.billArr = []
            that.total = that.billArr.length
            console.log('else--' + that.billArr)
            that.handleCurrentChange(1)
          }

        }).catch(() => {
          that.loading = false
          that.$message.error('账单记录查询失败')
        })
      },
      handleSizeChange (val) {
        this.currentPage = val
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.tableData = this.billArr.slice((val - 1) * this.pageSize, this.pageSize * val)
      },

      // 获取登录人的信息，根据账号密码获得北燃的token
      getBjtongAccessToken (code) {
        const that = this
        that.loading = true
        const params = {
          grantCode: code,
          operationType: '查询'
        }
        getBjtongAccessToken(params).then(res => {
          if (res.data.success) {
            that.telephone = res.data.rows[0].userName
            that.password = res.data.rows[0].passwordEncrypted
            window.localStorage.userId = res.data.rows[0].id
            that.toAccountNumberManagement()
          } else {
            that.loading = false
            this.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 登录
      toAccountNumberManagement () {
        const that = this
        const params = {
          client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
          client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
          grant_type: 'password',
          username: that.telephone,
          password: 'Bjtong'
        }
        getToken(params).then(res => {
          that.onLogin(res.data)
        }).catch(() => {
          that.loading = false
          that.$message.error('用户名或密码错误')
        })
      },

      // 获取token成功
      onLogin (resp) {
        const that = this
        window.localStorage.smartHistory = ''
        if (resp.access_token) {
          window.localStorage.tokenType = resp.token_type
          window.localStorage.token = resp.access_token
          that.loading = false
        } else {
          that.loading = false
          this.$message.error('获取token失败')
        }
      },

      // 校验户号并绑定
      checkUserGas () {
        const that = this
        if (that.formInline.gasAccount === '') {
          that.$message({
            message: '请输入燃气户号',
            type: 'warning'
          })
          return
        }
        that.loading = true
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.formInline.gasAccount
        }
        checkUserGas(params).then(res => {
          if (res.data.success) {
            that.topMainArr[0].value = res.data.rows[0].gasAccount
            // C卡表，R普表，NB智能表
            if (res.data.rows[0].meterType === 'C') {
              that.topMainArr[1].value = '卡表'
            }
            if (res.data.rows[0].meterType === 'R') {
              that.topMainArr[1].value = '普表'
            }
            if (res.data.rows[0].meterType === 'NB') {
              that.topMainArr[1].value = '智能表'
            }
            that.topMainArr[2].value = res.data.rows[0].address
            that.getData()
            that.operationRecords()
          } else {
            that.topMainArr[0].value = ''
            that.topMainArr[1].value = ''
            that.topMainArr[2].value = ''
            that.billArr = []
            that.tableData = []
            that.currentPage = 1
            that.pageSize = 10
            that.total = 0
            that.loading = false
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 记录用户操作类型
      operationRecords () {
        const that = this
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.formInline.gasAccount,
          operationType: '查询'
        }
        operationRecords(params).then(res => {
          if (res.data.success) {
          } else {
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      }
    },

  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .account-div {
    position: relative;
    left: 15%;
    font-size: 25px;
    font-weight: bolder;
    /*padding-top: 25px;*/
    padding-bottom: 25px;
    width: 70%;
  }

  .table-div {
    position: relative;
    left: 20%;
    width: 65%;
  }

  .page-div {
    position: relative;
    left: 65%;
    padding-top: 30px;
    padding-bottom: 50px;
    width: 150px;
  }


  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #BD1A2D;;
    color: #fff;
  }

  .query-div {
    text-align: center;
    padding-top: 25px;
  }

  .query-button, .query-button:focus, .query-button:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }
</style>
